/**
 * Constants for Trial Dashboard and Annotation Features
 */

// Transcript Polling Configuration
export const TRANSCRIPT_POLLING = {
  INTERVAL_MS: 30000, // Poll every 30 seconds
  MAX_ATTEMPTS: 20, // Maximum polling attempts (10 minutes at 30s intervals)
  MESSAGE_DURATION_MS: 3000, // Duration to show success/info messages
};

// Sales Pitch Polling Configuration
export const SALES_PITCH_POLLING = {
  INTERVAL_MS: 30000, // Poll every 30 seconds
  MAX_ATTEMPTS: 10, // Maximum polling attempts (5 minutes at 30s intervals)
  MESSAGE_DURATION_MS: 3000, // Duration to show success/info messages
};

// AI Analysis Polling Configuration
export const AI_ANALYSIS_POLLING = {
  INTERVAL_MS: 30000, // Poll every 30 seconds
  MAX_ATTEMPTS: 40, // Maximum polling attempts (20 minutes at 30s intervals)
  MESSAGE_DURATION_MS: 3000, // Duration to show success/info messages
};

// Trial Part Options
export const TRIAL_PARTS = [
  { value: 'Trial Part 1', label: 'Trial Part 1' },
  { value: 'Trial Part 2', label: 'Trial Part 2' },
  { value: 'Trial Part 3', label: 'Trial Part 3' },
];

// Annotation Emotion Types
export const ANNOTATION_EMOTIONS = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};

export const ANNOTATION_EMOTION_OPTIONS = [
  { value: ANNOTATION_EMOTIONS.NEGATIVE, label: 'Negative' },
  { value: ANNOTATION_EMOTIONS.POSITIVE, label: 'Positive' },
];

export const AI_ANALYSIS_SEVERITY_COLORS = {
  High: '#dc3545',
  Medium: '#ffc107',
  Low: '#28a745',
};

// Error Messages
export const ERROR_MESSAGES = {
  VIDEO: {
    SIGNED_URL_FAILED: 'Unable to load video. Please try again.',
    NO_TRIAL_DATA: 'No trial data available. Please return to the trial dashboard.',
    INVALID_URL: 'Invalid video URL format.',
    PARSE_FAILED: 'Failed to process video URL.',
    NO_VIDEO_AVAILABLE: 'No video available for this trial.',
  },
  TRANSCRIPT: {
    NOT_FOUND: 'Transcript not found',
    NOT_AVAILABLE:
      'Transcript not available yet. The recording is still being processed — please check back shortly.',
    FETCH_FAILED: 'Unable to load transcript. Please try again.',
    INVALID_VIDEO_ID: 'Invalid video identifier.',
    STATUS_CHECK_FAILED: 'Unable to check transcript status after multiple attempts.',
    // TIMEOUT is referenced from the polling loop in
    // trial-dashboard/annotate-page.jsx. That loop is unreachable
    // after the trigger-on-miss removal — nothing returns
    // ``processing: true`` anymore — but the constant stays until
    // the polling state machine is deleted in a follow-up.
    TIMEOUT:
      'Transcript generation is taking longer than expected. Please try refreshing manually.',
  },
  SALES_PITCH: {
    NOT_FOUND: 'Sales pitch not found',
    FETCH_FAILED: 'Unable to load sales pitch. Please try again.',
    TRIGGER_FAILED: 'Unable to generate sales pitch. Please try again.',
    INVALID_CLASSROOM_ID: 'Invalid classroom identifier.',
    CREATE_FAILED: 'Unable to start sales pitch generation.',
    TIMEOUT:
      'Sales pitch generation is taking longer than expected. Please try refreshing manually.',
    STATUS_CHECK_FAILED: 'Unable to check sales pitch status after multiple attempts.',
    GENERATING: 'Sales pitch generation started. This may take 2-5 minutes...',
    STILL_PROCESSING: 'Sales pitch is being generated. Please wait...',
  },
  AI_ANALYSIS: {
    NOT_FOUND: 'AI analysis not found',
    FETCH_FAILED: 'Unable to load AI analysis. Please try again.',
    TRIGGER_FAILED: 'Unable to generate AI analysis. Please try again.',
    INVALID_CLASSROOM_ID: 'Invalid classroom identifier.',
    CREATE_FAILED: 'Unable to start AI analysis generation.',
    TIMEOUT:
      'AI analysis generation is taking longer than expected. Please try refreshing manually.',
    STATUS_CHECK_FAILED: 'Unable to check AI analysis status after multiple attempts.',
    GENERATING: 'AI analysis generation started. This may take a few minutes...',
    STILL_PROCESSING: 'AI analysis is being generated. Please wait...',
  },
  API: {
    FETCH_TRIALS_FAILED: 'Failed to load trials data. Please try again.',
    FILTER_FAILED: 'Failed to apply filters. Please try again.',
    SEARCH_FAILED: 'Failed to search trials. Please try again.',
    NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  },
};

// Success Messages
export const SUCCESS_MESSAGES = {
  TRANSCRIPT: {
    LOADED: 'Transcript loaded successfully!',
    POLLING:
      'Transcript generation has been triggered. Polling every 30 seconds for completion...',
  },
  SALES_PITCH: {
    LOADED: 'Sales pitch loaded successfully!',
    POLLING:
      'Sales pitch generation has been triggered. Polling every 30 seconds for completion...',
    DURATION_MESSAGE: 'This might take 2-10 minutes.',
  },
  AI_ANALYSIS: {
    LOADED: 'AI analysis loaded successfully!',
    POLLING:
      'AI analysis generation has been triggered. Polling every 30 seconds for completion...',
    DURATION_MESSAGE: 'This might take a few minutes.',
  },
};
